module.exports = __webpack_public_path__ + "media/it_it_s1_Giulia.060eec12.mp3";